/** Default: 24h — must match backend `INBOX_SNOOZED_RETURNED_LABEL_TTL_MS` when unset. */
const DEFAULT_TTL_MS = 24 * 60 * 60 * 1000

export function getSnoozedReturnedLabelTtlMs(): number {
    const raw = process.env.REACT_APP_INBOX_SNOOZED_RETURNED_LABEL_TTL_MS
    if (raw === undefined || raw === null || String(raw).trim() === '') {
        return DEFAULT_TTL_MS
    }
    const parsed = Number(raw)
    if (!Number.isFinite(parsed) || parsed <= 0) {
        return DEFAULT_TTL_MS
    }
    return parsed
}

/** Prefer API `showSnoozedReturnedLabel`; fallback for stale clients. */
export function shouldShowSnoozedReturnedLabel(
    conversation: { snoozedUntil?: number | null; showSnoozedReturnedLabel?: boolean },
    now = Date.now(),
): boolean {
    if (typeof conversation.showSnoozedReturnedLabel === 'boolean') {
        return conversation.showSnoozedReturnedLabel
    }
    const snoozedUntil = conversation.snoozedUntil
    if (snoozedUntil == null || snoozedUntil <= 0 || snoozedUntil > now) {
        return false
    }
    return now - snoozedUntil < getSnoozedReturnedLabelTtlMs()
}
